import React from 'react';
import styled from 'styled-components';
import MsxIcons from '../features/msx-icons';
import I10n from '../features/i10n';
import { PRIMARY_COLOR } from '../color-constants';

const FilterIcon = styled.div`
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 5px;
`;

const TotalQuestionsAnsweredWrapper = styled.div`
  display: ${props => props.questionsAnswered >= 1 ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-left: 20px;
  background-color: #008a16;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  font-size: x-small;
`;

const FilterToggleIcon = styled(MsxIcons)`
  margin-left: auto;
  position: relative;
  right: ${props => props.isFilterOpen ? '8px' : '10px'};
  margin-top: 1px;
`;

const FilterHeaderWrapper = styled.div`
  cursor: pointer;
  border-radius: 20px;
  height: 30px;
  box-sizing: border-box;
  border: ${props => props.isFilterOpen ? 'none' : '1px solid #E6E6E6'};
  display: flex;
  width: ${props => props.isFilterOpen ? '' : '350px' };
  justify-content: flex-start;
  align-items: center;
  background-color: white;

  @media (max-width: 800px) {
    width: 100%;
    box-sizing: border-box;
  }
`;

const ContentWrapper = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 800px) {
    overflow: hidden;
    height: 100%;
    ${props => props.isMobileOpen ? 'padding-right: 20px; padding-top: 5px; padding-left: 16px; padding-bottom: 50px;' : ''}
  }
`;

const FilterTitle= styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
`;
class FilterHead extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isFilterOpen: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFilterOpen !== this.props.isFilterOpen) {
      this.setState({ isFilterOpen: this.props.isFilterOpen });
    }
  }

  render() {
    return (
      <ContentWrapper id="FilterHead 1" isMobileOpen={this.props.mobileFilterOpened}>
        <FilterHeaderWrapper id="FilterHead 2" isFilterOpen={this.props.isFilterOpen}
          onClick={() => {
            if (this.props.toggleFilter && typeof this.props.toggleFilter === 'function') {
              this.props.toggleFilter();
            }
          }}
        >
          <FilterIcon id="FilterHead 3">
            <MsxIcons name="filter2" size="small" />
          </FilterIcon>
          <FilterTitle id="FilterHeader 7">
            {I10n.get(`screen.head_device_selector_screen.plc.filters`)}
            <TotalQuestionsAnsweredWrapper id='FilterHead 4' questionsAnswered={this.props.numberQuestionsAnswered}>
              {this.props.numberQuestionsAnswered}
            </TotalQuestionsAnsweredWrapper>
          </FilterTitle>
          <FilterToggleIcon
            id="FilterHead 5"
            name={this.props.isFilterOpen ? "bold-up-arrow" : "bold-down-arrow"}
            size="nano"
            isFilterOpen={this.props.isFilterOpen}
          />
        </FilterHeaderWrapper>
      </ContentWrapper>
    );
  }

}


export default FilterHead;
